export default {
  commonTexts: {
    button: {
      save: 'Save',
      cancel: 'Cancel',
      back: 'Back',
    },
    removeModal: {
      label: 'Do you really wish to delete the ribbon?',
      agreeButton: 'Yes',
      cancelButton: 'No',
    },
    tableProductsHeader: {
      name: 'Name',
      vendorCode: 'Vendor code',
      price: 'Price',
      action: '',
    },
    multiselect: {
      submitButton: 'Add to actions',
      cancelButton: 'Cancel',
      selectAllButton: 'Select all',
      selectNoneButton: 'Select none',
      products: {
        placeholder: 'Product name, SKU, UPC',
        pageText: 'Page',
        emptyList: {
          title: "There isn't such product",
          description:
            'Try a different name or clear your search to see all products',
        },
      },
      categories: {
        placeholder: 'Category title',
        emptyList: {
          title: "There isn't such category",
          description:
            'Try a different name or clear your search to see all categories',
        },
      },
    },
  },
  indexPage: {
    bundlesAreaTitle: 'Product bundles',
    bundlesAreaSubtitle:
      'You can edit and delete bundles, as well as enable and disable them without deleting',
    pageTitle: 'Product Bundles',
    addLabelAreaTitle: 'Highlight your products',
    addLabelAreaSubtitle:
      'Combine different items to sell them together with a discount. Motivate customers to add more products to their carts and spend more money!',
    faqAreaTitle: 'FAQ',
    faqAreaSubtitle: {
      html: 'A detailed guide on how to use an app. If you need any help or have any problems please don\'t hesitate to <a href="https://simcase-apps.omnidesk.ru/?send=question" target="_blank">contact us</a> directly. We are here to help',
    },
    faq: {
      question1: {
        title: 'Promo Item Header',
        content:
          'Advertise and sell your products directly through your page and reach billions of potential customers. Advertise and sell your products directly through your page and reach billions of potential customers.',
      },
    },
    iconableBlockTitle: 'Bundle products',
    iconableBlockDescription:
      'Create bundles that make sense, such as holiday sets or complementary goods combo. Help your customers to find the best addition to their carts and offer the discount for the bundle',
    addNewBundle: 'Create product bundles',
    card: {
      action: 'Actions',
      actionUpdate: 'Edit',
      actionDelete: 'Remove',
    },
    removeBundleModal: {
      label: 'Do you really want to remove this bundle?',
      agreeButton: 'Agree',
      cancelButton: 'Cancel',
    },
  },
  homePage: {
    title: 'Product Availability Scheduler',
    addToShopArea: {
      title: 'Create a new promotion',
      subtitle:
        'Select the products and specify, when they will not be available for customers',
      interactiveBlock: {
        title: 'Easy launches and flash-sales',
        subtitle:
          'Automatic product scheduling: choose when your products are available and when they are not',
        buttonText: 'Set Up Promotion',
      },
    },
    promotionsArea: {
      title: 'Manage Happy Hour promotions',
      subtitle:
        'Easily enable or disable any promotion,  manage date and time when products are available or not. You can also add ribbons to highlight availability',
      interactiveBlock: {
        emptyBlockTitle: 'Actions list is empty',
        emptyBlockErrorTitle: 'Failed to load actions list',
        actionButton: {
          title: 'Actions',
          actionsList: {
            edit: 'Edit',
            delete: 'Delete',
          },
        },
      },
    },
    shopRevisionArea: {
      title: 'Tailor the store to your needs',
      subtitle:
        'Sometimes just a discount is not enough: you need to tell the buyer which product to add to the cart.',
      interactiveBlock: {
        title: 'Manual recommendations tool',
        subtitle:
          'Help your Merchants to collect all items for 1+1=3 promotion by showing them accessories, complementary products, or higher-end alternatives!',
        buttonText: 'Recommend products',
      },
    },
    bannerAreaTheFirst: {
      title: 'Combine items and sell more',
      subtitle:
        'Maximize your profit easily by grouping several items and selling them together with combo offers! You can create gift sets, combine bestsellers and less popular items, or bundle frequently bought together products. Add this tool to your store to sell more products with no additional transaction costs',
      buttonText: 'Create a bundle',
    },
  },
  detailPromotionPage: {
    title: 'Settings',
    setupPromotionArea: {
      title: 'Set up the promotion',
      subtitle:
        'Select products and specify when they will not be available for the customers. You can add a few time frames, or start the promotion immediately, or make it permanent. There are special checkboxes for these options',
      interactiveBlock: {
        section_1: {
          toggleHint: 'Status (Enabled / Disabled)',
          textOff: 'Off',
          textOn: 'On',
        },
        section_2: {
          title_1: 'Promotion Schedule',
          parameter: {
            title: 'Discount type',
            option_1: 'percentage',
            option_2: 'fixed amount',
          },
          meaning: {
            title: 'Value',
            hint_1:
              'Value (100% means a customer will get the product for free)',
          },
          title_2: 'Description',
          title_3:
            'Short description (up to 50 characters) will be displayed at checkout, when a customer adds all the products required for the promotion to their cart',
          descriptionPlaceholder: 'Enter a description',
          descriptionError: 'Description must not be empty',
        },
        section_3: {
          title_1: 'Promotion start',
          dateBlock: {
            title_1: 'Time',
            title_2: 'Date',
          },
          checkboxBlock: {
            text: ' Start the promotion now',
          },
        },
        section_4: {
          title_1: 'Promotion end',
          dateBlock: {
            title_1: 'Time',
            title_2: 'Date',
          },
          checkboxBlock: {
            text: 'Make the promotion permanent',
          },
          error: {
            text: 'End date should be grater than start date',
          },
        },
      },
    },
    setupTimeSlotsArea: {
      mainTitle: 'Choose products for the promotion',
      subMainTitle:
        'Select product categories, or specific products, for the promotion. The discount will be applied according to the schedule you set',
      title: 'Create a schedule ',
      subtitle:
        'You can select one or more time frames to specify start and end dates. You can combine time frames to set the promotion to repeat automatically',
      interactiveBlock: {
        title: 'Promotion Schedule',
        subtitle:
          'Add time frames to make products unavailable for the purchase',
        button: 'Add time frame',
        section_1: {
          title_1: 'Product will become unavailable',
          placeholder_1: 'Time',
          title_2: 'Product will become available again',
          placeholder_2: 'Date',
        },
        section_2: {
          title_1: 'Promotion repeat',
          option_1: 'Do not repeat',
          option_2: 'Every week - with day selection',
          option_3: 'Every month - ',
          option_4_start: 'Repeat every',
          option_4_ending: 'day of month',
          weekdays: [
            'from sunday every',
            'from monday every',
            'from tuesday every',
            'from wednesday every',
            'from thursday every',
            'from friday every',
            'from saturday every',
          ],
          option_3_ending: ' week',
          daysOptions: [
            'Monday',
            'Tuesday',
            'Wednesday',
            'Thursday',
            'Friday',
            'Saturday',
            'Sunday',
          ],
          title_2: 'Start day',
          daysSelectPlaceholder: 'Select day of the week',
        },
        section_3: {
          title: 'Restrict to',
          checkboxText: 'Do not restrict promotion',
        },
        section_4: {
          question: 'Are you sure you want to delete the time slot?',
          agree: 'Yes',
          cancel: 'No',
        },
      },
    },
    setupPurchaseArea: {
      title: 'Choose products for the promotion',
      subtitle:
        'Select product categories, or specific products, for the promotion. The discount will be applied according to the schedule you set',
      interactiveBlock: {
        productsBinding: {
          title: 'Choose products for the promotion',
          subtitle:
            'Manually select specific products the discount will be applied to',
          buttonAddItemsText: ['items', 'items', 'item'],
        },
        productCategoriesBinding: {
          title: 'Choose product categories for the promotion',
          subtitle: 'Select product categories the discount will be applied to',
        },
      },
    },
    labelsArea: {
      title: 'Product Ribbons',
      subtitle:
        'Draw customers’ attention to your promotion with special labels. Your ribbons can highlight products that soon will be available',
      interactiveBlock: {
        beforePromotion: {
          title: 'Create a ribbon to display before the promotion',
          description:
            'Create excitement around your store by adding special labels that indicate when the promotion starts',
          inputTitle: 'Ribbon text',
        },
        duringPromotion: {
          title: 'Create a ribbon to display during the promotion',
          description:
            'Show your customers when the promotion ends to encourage them to buy products now',
          inputTitle: 'Ribbon text',
        },
        colorPicker: {
          title: 'Ribbon color',
          customColor: 'Custom Ribbon Color',
        },
        input: {
          inputPlaceholder: 'For example, ‘Coming soon’',
        },
        helpTextFinish:
          'The text field can contain only 30 symbols. You can also insert {end_time} and {end_date} variables',
        helpBubbleFinish:
          '{end_time} - promotion end time; {end_date} - promotion end date',
        helpTextStart:
          'The text field can contain only 30 symbols. You can also insert {start_time} and {start_date} variables',
        helpBubbleStart:
          '{start_time} - promotion start time; {start_date} - promotion start date',
        ribbonPreview: 'Ribbon preview',
        deleteRibbon: 'Remove this ribbon',
      },
    },
    FAQ_Area: {
      title: 'FAQ',
      subtitle:
        "A detailed guide on how to use the app. If you cannot find the answer you are looking for, don't hesitate to contact us directly. We are here to help",
    },
  },
};
